import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        load: 0,
        showHeaderModal: 0
    },

    mutations: {
        load ( state, value ) {
            state.load += value === 1 ? 1 : -1;
            if ( state.load < 0 ) {
                state.load = 0;
            }
        },

        showHeaderModal(state, showHeaderModal){
            state.showHeaderModal = showHeaderModal;
        }
    },

    getters: {
        showHeaderModal: state => state.showHeaderModal,
    }
});


